export default __webpack_public_path__ + "static/media/025-latte macchiato.bd06934a.svg";